import request from './request'
const path = 'merchants.api.menu.'
const dictApi = {
  /** 查询字典类型*/
  findDictType(data = {}) {
    data.method = `${path}findDictType`
    return request(data)
  },
  /** 删除字典类型 */
  deleteDictType(data = {}) {
    data.method = `${path}deleteDictType`
    return request(data)
  },
  /** 保存字典类型 */
  saveDictType(data = {}) {
    data.method = `${path}saveDictType`
    return request(data)
  },
  /** 更新字典类型 */
  updateDictType(data = {}) {
    data.method = `${path}updateDictType`
    return request(data)
  },
  /** 查询字典数据列表 */
  findDictData(data = {}) {
    data.method = `${path}findDictData`
    return request(data)
  },
  /** 删除字典数据 */
  deleteDictData(data = {}) {
    data.method = `${path}deleteDictData`
    return request(data)
  },
  /** 保存字典数据 */
  saveDictData(data = {}) {
    data.method = `${path}saveDictData`
    return request(data)
  },
  /** 更新字典数据 */
  updateDictData(data = {}) {
    data.method = `${path}updateDictData`
    return request(data)
  },
  /** 查询所有字典 */
  findAllDictData(data = {}) {
    data.method = `${path}findAllDictData`
    return request(data)
  }
}

export { dictApi }
